import React, { useMemo } from 'react';
import Button from '../../components/Buttons/button';
import H2 from '../../components/Titles/h2';
import Hr from '../../components/Style/hr';
import CardProductCart from './card-product-cart';
import { useTranslation } from 'react-i18next';
import { useCart } from '../../contexts/cart-context';

export default function StepCheckCart({ products, returnedData }) {
    const { t } = useTranslation();
    const { cart } = useCart();

    const formatPrice = (n) => {
        const num = Number(n);
        if (!Number.isFinite(num)) return '0.00€';
        return `${num.toFixed(2)}€`;
    };

    const totals = useMemo(() => {
        const findQuantity = (slug, reference) => {
            const line = cart.find(
                (c) => c.slug === slug && c.reference === reference
            );
            return line ? Number(line.quantity) || 0 : 0;
        };

        let subtotalHT = 0;
        let subtotalTTC = 0;

        (products || []).forEach((p) => {
            if (!p.modelProduct || !p.modelProduct.length) return;

            const vatRate = Number(p.VAT) || 0;

            // On parcourt tous les modèles pour être safe
            p.modelProduct.forEach((model) => {
                const quantity = findQuantity(p.slug, model.reference);
                if (!quantity) return;

                const priceTTC = Number(model.priceTTC) || 0;
                const lineTTC = priceTTC * quantity;

                const lineHT =
                    vatRate > 0
                        ? lineTTC / (1 + vatRate / 100)
                        : lineTTC;

                subtotalTTC += lineTTC;
                subtotalHT += lineHT;
            });
        });

        const totalTVA = Math.max(subtotalTTC - subtotalHT, 0);

        return {
            subtotalHT,
            subtotalTTC,
            totalTVA,
        };
    }, [products, cart]);

    const handleButtonClick = () => {
        returnedData('personnalInfos');
    };

    return (
        <div className="flex flex-col lg:flex-row gap-12">
            {/* Colonne gauche : produits */}
            <div className="bg-white shadow p-4 w-full h-fit lg:w-2/3">
                <H2
                    title={t('cart.myCart')}
                    theme="main"
                    fontWeight="semibold"
                />
                <Hr />

                {!products.length ? (
                    <div className="py-6 text-gray-500 text-sm">
                        {t('cart.emptyCart')}
                    </div>
                ) : (
                    products.map((product, index) => (
                        <div key={product.slug || index}>
                            <CardProductCart product={product} />
                            {index !== products.length - 1 && <Hr />}
                        </div>
                    ))
                )}
            </div>

            {/* Colonne droite : total */}
            <div className="bg-white shadow p-4 h-fit w-full lg:w-1/3">
                <H2
                    title={t('cart.total')}
                    theme="main"
                    fontWeight="semibold"
                />
                <Hr />

                <div className="flex justify-between text-gray font-light text-lg md:text-2xl">
                    <span>{t('cart.subtotalHT')}</span>
                    <span>{formatPrice(totals.subtotalHT)}</span>
                </div>

                <Hr />

                <div className="flex justify-between text-gray font-light text-sm md:text-base mt-2">
                    <span>{t('cart.totalVAT')}</span>
                    <span>{formatPrice(totals.totalTVA)}</span>
                </div>

                <div className="flex justify-between text-black font-bold text-lg md:text-2xl mt-3">
                    <span>{t('cart.totalTTC')}</span>
                    <span>{formatPrice(totals.subtotalTTC)}</span>
                </div>

                <div className="w-full text-center m-auto pt-8">
                    <Button
                        text={t('cart.nextStep')}
                        onClick={handleButtonClick}
                    />
                </div>
            </div>
        </div>
    );
}